module.exports = {
      id: "success-usage",
      viewBox: "0 0 82 82",
      url: __webpack_public_path__ + "svg-sprite-b468923450c663eeca769f8899a6b186.svg#success",
      toString: function () {
        return this.url;
      }
    }